<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="banner-title">
                    <div class="title">
                        <h1>無料オンラインスペルチェックツール
                        </h1>
                    </div>
                    <p>Trinka（トリンカ）の無料スペルチェックツールで、リアルタイムにスペルミスを修正しましょう。<br/>
                        単語のスペルがおぼつかないこと、よくありませんか？TrinkaのAIは、専門分野に基づいた正しいスペルを識別し、文脈に応じた提案をして文章全体を改善します。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                    </ul>
                    <app-english-grammar-checker></app-english-grammar-checker>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="trinka-banner section-pd-sm d-lg-block d-none" id="real-time">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">TrinkaをChromeにインストールしていつでもスペルチェックを
                    </h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a  id="GCChromeButton2" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" class="white-btn" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome - 文法 チェック">Chromeにインストール</a>
                    <a  id="GCFirFoxButton2" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" class="white-btn" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox - 文法 チェック"> Firefox にインストール</a>
                    <a  id="GCEdgeButton2" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" class="white-btn" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法 チェック"> Edge にインストール</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="signupmobile trinka-banner section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">無料アカウントで<br>もっとチェック！</h3>
                    <p class="text-white">Trinkaへのご登録で、毎月5千単語まで英文チェックが無料。文法、スペル、文体の精度向上にご活用ください。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">今すぐ登録する</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="the_best_grammer_sections section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0">
                    <h2>突出した機能を持つ、無料オンラインスペルチェックツール</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>Trinkaのスペルチェックツールは、英語の文章の中の複雑なスペルミスを識別し、修正案を示します。</p>
                    <p>一般的なミスから識別しづらいミスまで、文法やスペルの誤りを高い精度で修正し、文書全体の質を向上させます。使い続けることで英語のライティングスキルも身に付きます。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>文脈に沿った高度なスペルチェック</li>
                            <li>精度の高い<a [routerLink]="['/grammar-checker']">文法チェック</a></li>
                            <li>ご利用は無料</li>
                            <li>高度なデータセキュリティ</li>
                        </ul>
                    </div>
                    <p>Trinkaのオンライスペルチェックツールーはスペルミスを検出し、分かりやすい解説と一緒に修正案を提示します。</p>
                    <p>アカウント登録いただければ、Trinkaのより多くの機能を無料でお使いいただけます。</p>
                    <div class="btn-group">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="filled-btn">さっそく始める</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">Trinkaの
                        スペルチェックツールは
                        誰に向いている？</h3>
                    <p class="text-white">Trinkaは、英語のライティングスキルを向上させたいすべての方に向いています。Trinkaの無料スペルチェックツールは、大学教員、学生、研究者、コピーライター、マーケター、プロダクトチーム、ブロガー、コンテンツライター、文筆家の方、その他多くの人々から信頼を得ています。</p>

                </div>
            </div>
        </div>  
    </div>
</div>


<div class="the_best_grammer_sections section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinkaスペルチェックツールの主な機能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高度なスペルチェック  </h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaの無料スペルチェックツールは、文章の文脈を捉えて、テーマに即したスペル、単語を提案します。厄介なスペルミスに悩まされることはありません。 </p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>すべての分野の文書に対応</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaをカスタマイズすれば、分野やコンテンツの種類に即した修正案が示されます。 </p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The physical properties of <span class="wrong_text">kytoplasm</span> <span
                                class="right_text"> cytoplasm</span> differ considerably from dilute aqueous solutions.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>マイ・ディクショナリー</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>ご自身専用の辞書機能「マイ・ディクショナリー」に追加した単語は、すべてのプラットフォーム上で自動的に同期して、どこからでもパーソナライズされたライティングを行えます。</p>
                        </div>
                        <div class="mini_card_grammer min_auto">
                            <!-- <h4>Syntax</h4> -->
                            <div class="toolbox_img_content publication_checks_section pd_after">
                                <div class="personal_dictionary_section">
                                    <div class="personal_dic_left_text">
                                        <h2>Spelling
                                            <span>
                                                <i class="fa fa-plus"></i>Add to dictionary</span>
                                        </h2>
                                        <div class="personal_dic_text_section">
                                            <p class="personal_wrong_text">nanotubol</p>
                                            <img src="../../../assets/images/spacingArrow.png" alt="間隔 - 英文チ ェッカー" />
                                            <p class="personal_right_text">nanotubes</p>
                                        </div>
                                        <p>Please check the spelling</p>
                                    </div>
                                    <div class="consistency_left_side">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        <ul>
                                            <li>
                                                <img src="../../../assets/images/Consistency_delete_icon.svg" alt="delete - ai英文校正" title="Delete" style="width: 22px;">
                                            </li>
                                            <li>
                                                <img src="../../../assets/images/consistency_dislike_icon.svg" alt="dislike - 英文 チェック ai" title="Incorrect suggestions" style="width: 20px;">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>変更提案の一括承認／すべて無視</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>論文中のスペルを修正する際、何度も提案されるのが煩わしい場面もあるでしょう。Trinkaならワンクリックで簡単に、変更の提案すべてを受け入れたり、無視したりできます。</p>
                        </div>
                        <div class="mini_card_grammer min_auto">
                            <!-- <h4>Advance Spelling</h4> -->
                            <div class="toolbox_img_content publication_checks_section pd_after">
                                <div class="personal_dictionary_section">
                                    <div class="personal_dic_left_text">
                                        <h2>Spelling
                                            <b>
                                                <i class="fa fa-plus"></i>Add to dictionary</b>
                                        </h2>
                                        <div class="personal_dic_text_section">
                                            <p class="personal_wrong_text">nanotubol</p>
                                            <img src="../../../assets/images/spacingArrow.png" alt="間隔 - 英文校正" />
                                            <p class="personal_right_text">nanotubes</p>
                                        </div>
                                        <div class="acceptAll_buttons_sections">
                                            <p>Accept for all similar alerts</p>
                                            <i>
                                                <img src="../../../assets/images/info.svg" alt="アイコン - 文法 チェック">
                                            </i>
                                        </div>
                                        <p>Please check the spelling</p>
                                    </div>
                                    <div class="consistency_left_side">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        <ul>
                                            <li>
                                                <img src="../../../assets/images/Consistency_delete_icon.svg" alt="アイコン" title="Delete" style="width: 22px;">
                                            </li>
                                            <li class="acceptAll_rejectAll">
                                                <img src="../../../assets/images/AcceptAll_consistencyCheks.svg" alt="すべてを受け入れる - 英文チ ェッカー" title="Ignore for all similar aterls" style="width: 22px;">
                                            </li>
                                            <li>
                                                <img src="../../../assets/images/consistency_dislike_icon.svg" alt="嫌い" title="Incorrect suggestions" style="width: 20px;">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    </div>
</div>


<div class="use_trinka_other_app section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white">プラグイン・アドインで、
                        いつでもどこでも
                        良質なライティングを</h3>
                </div>
                <div class="use_trinka_content">
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="無料の文法チェッカーツール">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd-in1.svg" alt="word - 文法 チェック">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome - 文法 チェック">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox - 文法 チェック">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法 チェック">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari - 文法 チェック">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>無料スペルチェックツールの機能はどんなもの？</h3>
                    <p>Trinkaのスペルチェックツールは、スペルミスだけでなく文法ミスも検出し修正。動詞の活用や時制、人称、似たスペルの紛らわしい言葉、専門用語など、さまざまなエラーを検出します。</p>
                    <p>Trinkaを使ってあらゆるタイプのスペルミスを修正することで、英語のメッセージを明確に、自信を持って伝えることができます。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/WritingMoreEffective.png" alt="無料の文法チェッカーアプリ">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>エラーフリーの英文を、Trinkaで</h3>
                    <p>最新の機械学習（ML）と自然言語（NLP）技術を用いて開発されたTrinkaのAI搭載スペルチェックツールは、一般的なエラーから複雑なエラーまで、単語のスペルミスを識別します。</p>
                    <p>研究論文、学術文書、電子メール、エッセイのスペルチェックなど、Trinkaはどのような英語の文書にも対応します。スペルチェックだけでなく、文法ミスの修正も簡単です。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image features-img">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="最高の文法チェッカーツール">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">高度な文法とスペルのチェックを、Trinkaで</h3>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="white-btn" id="grammerSignUpButton">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>無料登録する</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div> 

<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h2>Trinkaスペルチェックツールについてよくあるご質問</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCOneContent" aria-expanded="true"
                                        aria-controls="QuestionGCOneContent">
                                        スペルチェックツールとは何ですか？</a>
                                </div>
    
                                <div id="QuestionGCOneContent" class="collapse"
                                    aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>スペルチェックツールとは、文書中のスペルミスや誤字脱字を検出し、文脈に基づいて正しいスペルや単語に置き換えるツールです。</p>
                                    </div>
                                </div>
                            </div>        
                            
                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwoContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwoContent">Trinkaのスペルチェックツールはどうやって使うのですか？</a>
                                </div>
    
                                <div id="QuestionGCTwoContent" class="collapse"
                                    aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>このページの冒頭にある入力枠に英文を貼り付け、「修正結果を見る」をクリックしてください。Trinkaがスペルミスをハイライト表示し、文脈に応じた最適なスペル候補を示します。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            

                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThreeContent" aria-expanded="true"
                                        aria-controls="QuestionGCThreeContent"> Trinkaスペルチェックツールは無料で使えますか？</a>
                                </div>
    
                                <div id="QuestionGCThreeContent" class="collapse"
                                    aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>もちろんです。このページ冒頭の入力枠に英文を貼り付けて「修正結果を見る」をクリックすると、スペルをチェックしたり修正したりできます。300単語以上の英文をチェックしたい場合は、<a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="text-link">Trinkaにご登録</a>、より多くの機能を無料でご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFourContent" aria-expanded="true"
                                        aria-controls="QuestionGCFourContent">ウェブサイト上でもスペルチェックができますか？</a>
                                </div>
    
                                <div id="QuestionGCFourContent" class="collapse"
                                    aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Chrome、Firefox、Edge用の<a  [routerLink]="['/browser-plugin']" class="text-link">ブラウザプラグイン</a>をインストールすれば、どのウェブサイトでもTrinkaのスペルチェックツールを使うことができます。</p>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>